import type { BizyPageType } from '../store/use-bizy-page-context-store';

export const suggestedPromptsByPage: Record<BizyPageType, string[]> = {
	home: ["What's my team up to this week?", 'Who should I recognize today?', 'Catch me up on anything I missed'],
	'1on1': ['Prepare talking points for this meeting', 'Summarize action items from last session', 'What has this person been working on?'],
	goals: ['What goals are overdue?', 'Help me write a new goal', "Summarize my team's progress"],
	rewards: ['What rewards are trending?', 'How can I stretch my points?', 'Suggest rewards my team will like'],
	feed: ['Summarize recent recognition trends', 'What should I follow up on?', 'Who deserves recognition this week?'],
	team: ['Who needs coaching support?', 'Summarize team momentum', 'What should I discuss with my team this week?'],
};
